import React from "react";
import styles from "./ExtraDetailGroup.module.css";

function ExtraDetailGroup({ ExtraDetail }) {
const detailsString =
    ExtraDetail.Details?.map(
        (detail) => `${detail.Name?.trim()}${detail.Info ? ` ${detail.Info.trim()}` : ''}`,
    ).join(", ") || "";

  return (
    <div className={styles.ExtraDetailGroup}>
      <div className={styles.ExtraDetailName}>
        {ExtraDetail.DisplayName ? ExtraDetail.DisplayName : ExtraDetail.Name}:
      </div>
      <div className={styles.ExtraDetailDetails}>{detailsString}.</div>
    </div>
  );
}

export default ExtraDetailGroup;
